import { notifier } from '@geit/ui-components';
import qs from 'qs';
import { v4 } from 'uuid';
import { saveOriginalUrlBeforeLogin } from '../navigate.js';
import { LOCAL_STORAGE_KEY, DEFAULT_PUBLIC_MENUS_URL, API_ENDPOINTS, LOGIN_URL, AM_STORAGE_KEY, DEFAULT_MENUS_URL, HEADER_SOURCE, HEADER_SOURCE_MYEMPOWER, DEFAULT_ESHOP_BRNS_URL, NOTIFIER_UNAUTHORIZED_MESSAGE, NOTIFIER_UNAUTHORIZED_TITLE, NOTIFIER_UNAUTHORIZED_BUTTON_TEXT } from './constants.js';
import { checkMaskToken } from './masking.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const acquireToken = async config => {
  let token;
  try {
    token = transformApiToken(JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY[config.app].TOKEN) || "{}"), config.app);
    if (token.expiryAt && token.accessToken && token.refreshToken && (!config.requireApigeeToken || token.apigeeToken)) {
      if (!isTokenExpired(token)) {
        return token;
      }
      console.log("token expired, requesting a new token", "expired at", new Date(token.expiryAt));
      return await refreshToken(token.refreshToken, config);
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};
const isTokenExpired = token => {
  if (new Date(token.expiryAt - 20 * 1e3) > /* @__PURE__ */new Date()) {
    return false;
  }
  return true;
};
const refreshToken = async (refreshToken2, config) => {
  try {
    const response = await fetch(getRefreshTokenApiEndpoint(config), {
      headers: {
        Authorization: "Bearer ".concat(refreshToken2)
      }
    });
    if (!response.ok) {
      return null;
    }
    const token = await response.json();
    localStorage.setItem(LOCAL_STORAGE_KEY[config.app].TOKEN, JSON.stringify(token));
    return transformApiToken(token, config.app);
  } catch (e) {
    return null;
  }
};
const getCurrentUser = async (token, config) => {
  try {
    const headers = prepareHttpHeaders(token, config);
    const response = await fetch(getMeApiEndpoint(config), {
      headers
    });
    const user = await response.json();
    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("Unauthenticated");
      }
      return {};
    }
    return user;
  } catch (error) {
    if (error instanceof Error && error.message === "Unauthenticated") {
      throw error;
    }
    return {};
  }
};
const getUserDomains = async (token, config) => {
  const endpoint = getDomainsApiEndpoint(config);
  if (endpoint) {
    const headers = prepareHttpHeaders(token, config);
    const response = await fetch(endpoint, {
      headers
    });
    const domains = await response.json();
    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("Unauthenticated");
      }
      return {};
    }
    return domains;
  }
};
const saveUserDomain = async (token, config, id) => {
  const endpoint = getDomainsApiEndpoint(config);
  if (endpoint) {
    const headers = prepareHttpHeaders(token, config);
    const response = await fetch(endpoint, {
      headers: __spreadProps(__spreadValues({}, headers), {
        "Content-Type": "application/json"
      }),
      method: "PUT",
      body: JSON.stringify({
        id
      })
    });
    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("Unauthenticated");
      }
      return {};
    }
    return {};
  }
};
const checkCurrentUserFeatureAccess = async (token, config, featureCode) => {
  const endpoint = checkCurrentUserFeatureAccessApiEndpoint(config, featureCode);
  if (endpoint) {
    const headers = prepareHttpHeaders(token, config);
    const response = await fetch(endpoint, {
      headers
    });
    if (!response.ok) {
      switch (response.status) {
        case 401:
          throw new Error("Unauthenticated");
        case 403:
          const goHome = () => {
            if (window.location.pathname !== "/") {
              if (config.onNavigate) {
                config.onNavigate("/");
              } else {
                window.location.href = "/";
              }
            }
          };
          notifier.notify(NOTIFIER_UNAUTHORIZED_MESSAGE, {
            title: NOTIFIER_UNAUTHORIZED_TITLE,
            buttonText: NOTIFIER_UNAUTHORIZED_BUTTON_TEXT,
            onConfirm: goHome,
            onClose: goHome
          });
          break;
        case 500:
          const responseJson = await response.json();
          throw new Error(responseJson);
      }
      return false;
    }
    return true;
  }
};
const getMenus = async config => {
  const menusUrlOrObject = config.menu || DEFAULT_MENUS_URL;
  if (typeof menusUrlOrObject === "string") {
    let endpoint = menusUrlOrObject;
    if (config.appUrl) {
      if (!menusUrlOrObject.startsWith("http")) {
        endpoint = "".concat(config.appUrl).concat(menusUrlOrObject);
      }
    }
    const response = await fetch(endpoint);
    if (!response.ok) {
      return [];
    }
    const menus = await response.json();
    return menus;
  } else {
    return menusUrlOrObject;
  }
};
const getPublicMenus = async function () {
  let menusUrlOrObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_PUBLIC_MENUS_URL;
  if (typeof menusUrlOrObject === "string") {
    const response = await fetch(menusUrlOrObject);
    if (!response.ok) {
      return [];
    }
    const menus = await response.json();
    return menus;
  } else {
    return menusUrlOrObject;
  }
};
const getEshopBRNs = async config => {
  const url = config.accessibleEShopUrl || DEFAULT_ESHOP_BRNS_URL;
  let endpoint = url;
  if (config.appUrl) {
    if (!url.startsWith("http")) {
      endpoint = "".concat(config.appUrl).concat(url);
    }
  }
  const response = await fetch(endpoint);
  if (!response.ok) {
    return [];
  }
  const brns = await response.json();
  return brns;
};
const getFeatures = async (token, config) => {
  const headers = prepareHttpHeaders(token, config);
  const response = await fetch(getFeaturesApiEndpoint(config), {
    headers
  });
  const user = await response.json();
  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Unauthenticated");
    }
    return {};
  }
  return user;
};
const getCurrentUserPermission = async (token, config, feature, permissionType) => {
  const headers = prepareHttpHeaders(token, config);
  const response = await fetch(getUserPermissionApiEndpoint(config, feature, permissionType), {
    headers
  });
  const userPermission = await response.json();
  if (!response.ok) {
    switch (response.status) {
      case 401:
        throw new Error("Unauthenticated");
      case 500:
        throw new Error(userPermission);
    }
    return {};
  }
  return userPermission;
};
const prepareHttpHeaders = (token, config) => {
  var _a;
  const headers = {};
  if (config.requireApigeeToken) {
    const uuid = v4();
    headers["Authorization"] = "Bearer ".concat(token.apigeeToken);
    headers["X-Authorization"] = "Bearer ".concat(token.accessToken);
    headers["X-Correlation-Id"] = uuid;
  } else {
    headers["Authorization"] = "Bearer ".concat(token.accessToken);
  }
  headers["X-Customer-Id"] = "0";
  if (isAMUser()) {
    headers[HEADER_SOURCE] = HEADER_SOURCE_MYEMPOWER;
  }
  const maskToken = (_a = checkMaskToken()) == null ? void 0 : _a.token;
  if (maskToken) {
    headers["X-display-key"] = maskToken;
  }
  return headers;
};
const clearToken = config => {
  localStorage.removeItem(LOCAL_STORAGE_KEY[config.app].TOKEN);
};
const getRefreshTokenApiEndpoint = config => {
  return "".concat(config.apiBaseUrl || "/api").concat(API_ENDPOINTS[config.app].refreshToken);
};
const getMeApiEndpoint = config => {
  return "".concat(getApiHostName(config)).concat(API_ENDPOINTS[config.app].me);
};
const getDomainsApiEndpoint = config => {
  const domainsApi = API_ENDPOINTS[config.app].domains;
  if (domainsApi) {
    return "".concat(getApiHostName(config)).concat(domainsApi);
  }
};
const getSendUnmaskingOtpApiEndpoint = config => {
  const pathname = API_ENDPOINTS[config.app].sendUnmaskingOtp;
  if (pathname) {
    return "".concat(getApiHostName(config)).concat(pathname);
  }
};
const getVerifyUnmaskingOtpApiEndpoint = config => {
  const pathname = API_ENDPOINTS[config.app].verifyUnmaskingOtp;
  if (pathname) {
    return "".concat(getApiHostName(config)).concat(pathname);
  }
};
const checkCurrentUserFeatureAccessApiEndpoint = (config, featureCode) => {
  const featureAccessApi = API_ENDPOINTS[config.app].featureAccess;
  if (featureAccessApi) {
    return "".concat(getApiHostName(config)).concat(featureAccessApi, "/").concat(featureCode);
  }
};
const getFeaturesApiEndpoint = config => {
  return "".concat(getApiHostName(config)).concat(API_ENDPOINTS[config.app].feature);
};
const getUserPermissionApiEndpoint = (config, feature, permissionType) => {
  const featureCode = getFeatureCode(feature);
  const featureCodeParams = typeof feature === "string" ? {
    featureCode
  } : {
    featureCode,
    isFeatureName: !(feature == null ? void 0 : feature.featureCode)
  };
  const params = __spreadValues(__spreadValues({}, featureCodeParams), permissionType);
  return "".concat(getApiHostName(config)).concat(API_ENDPOINTS[config.app].userPermission, "?").concat(qs.stringify(params, {
    skipNulls: true
  }));
};
const getApiHostName = config => {
  return config.requireApigeeToken ? config.apigeeBaseUrl : config.apiBaseUrl || "/api";
};
const transformApiToken = (apiToken, app) => {
  const token = {
    accessToken: app === "empower" ? apiToken.tokenA : apiToken.tokenB,
    apigeeToken: app === "empower" ? apiToken.tokenB.access_token : void 0,
    refreshToken: app === "empower" ? apiToken.tokenC : apiToken.refreshToken,
    expiryAt: apiToken.expiryAt,
    tokenType: apiToken.tokentype
  };
  return token;
};
const getUserAvatarName = (firstName, lastName) => {
  return (firstName || "").substring(0, 1).toUpperCase() + (lastName || "").substring(0, 1).toUpperCase();
};
const loginRedirect = async config => {
  await new Promise(resolve => {
    clearToken(config);
    saveOriginalUrlBeforeLogin(config.isExternal);
    window.location.href = LOGIN_URL[config.app];
  });
};
const getFeatureCode = feature => {
  if (typeof feature === "string") {
    return feature;
  } else if (feature == null ? void 0 : feature.featureCode) {
    return feature.featureCode;
  } else {
    return feature == null ? void 0 : feature.featureName;
  }
};
const isAMUser = () => localStorage.getItem(AM_STORAGE_KEY.IS_AM_USER) === "true";
const sendUnmaskingOtp = async (token, config, name) => {
  const endpoint = getSendUnmaskingOtpApiEndpoint(config);
  if (endpoint) {
    const headers = prepareHttpHeaders(token, config);
    return fetch("".concat(endpoint).concat(name ? "?name=".concat(name) : ""), {
      headers
    }).then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          return Promise.reject(errorData);
        });
      }
      return response.json();
    });
  }
  return void 0;
};
const verifyUnmaskingOtp = (token, config, payload) => {
  const endpoint = getVerifyUnmaskingOtpApiEndpoint(config);
  if (endpoint) {
    const headers = prepareHttpHeaders(token, config);
    return fetch(endpoint, {
      headers: __spreadProps(__spreadValues({}, headers), {
        "Content-Type": "application/json"
      }),
      method: "POST",
      body: JSON.stringify(payload)
    }).then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          return Promise.reject(errorData);
        });
      }
      return response.json();
    });
  }
  return void 0;
};
export { acquireToken, checkCurrentUserFeatureAccess, clearToken, getCurrentUser, getCurrentUserPermission, getEshopBRNs, getFeatureCode, getFeatures, getMenus, getPublicMenus, getUserAvatarName, getUserDomains, isAMUser, isTokenExpired, loginRedirect, refreshToken, saveUserDomain, sendUnmaskingOtp, verifyUnmaskingOtp };